var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "49",
      "height": "49"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#005149",
      "d": "M49 24.5C49 38.03 38.032 49 24.5 49S0 38.03 0 24.5 10.968 0 24.5 0 49 10.97 49 24.5"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M15 10c1.657 0 3 1.456 3 3.25 0 1.796-1.343 3.251-3 3.251s-3-1.455-3-3.25S13.343 10 15 10m-2.591 27h5.176V18.962h-5.176zM20 18.46h5.525v2.535h.103a6.06 6.06 0 0 1 5.456-2.99c5.848 0 6.916 3.837 6.916 8.826V37h-5.764v-9.013c0-2.15-.034-4.918-2.995-4.918-2.957 0-3.46 2.336-3.46 4.761V37h-5.758z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }